// i18n keys of the multi-tenant work package "cpackdocs" (en / zh / th). ⛔ Fill all three: an empty th value falls back to English.
export const en: Record<string, string> = {
  cpd_title: 'Country features',
  cpd_hint: 'What the country pack sets for documents and daily operations. A feature the country does not carry is left out and the screen falls back to a neutral default.',
  cpd_country: 'Country',
  cpd_country_unset: 'No country is set yet (Region above) — every feature uses the product default.',
  cpd_from_pack: 'country pack',
  cpd_default: 'product default',
  cpd_none: 'none',
  cpd_f_paperSize: 'Paper',
  cpd_f_docFonts: 'Document fonts',
  cpd_f_landAreaUnits: 'Land area units',
  cpd_f_addressParts: 'Address divisions',
  cpd_f_govPortals: 'Government portals',
  cpd_f_immigration: 'Immigration services',
  cpd_f_bankParsers: 'Bank statement readers',
  cpd_f_statutoryBooks: 'Statutory book names',
  cpd_langs: 'Interface languages',
  cpd_langs_hint: 'Untick a language to hide it from every language menu. With all ticked as the country offers them, the list follows the country.',
  cpd_langs_follow: 'Follow the country',
  cpd_langs_custom: 'Workspace choice',
  cpd_langs_need_one: 'Keep at least one language.',
  cpd_lang_en: 'English',
  cpd_lang_zh: 'Chinese',
  cpd_lang_th: 'Thai',
};
export const zh: Record<string, string> = {
  cpd_title: '国家/地区功能',
  cpd_hint: '国家/地区包为单据和日常操作设定的内容。该国没有的功能会被省略,界面改用中性的默认值。',
  cpd_country: '国家/地区',
  cpd_country_unset: '尚未设置国家/地区(见上方「地区」)——所有功能都使用产品默认值。',
  cpd_from_pack: '国家/地区包',
  cpd_default: '产品默认',
  cpd_none: '无',
  cpd_f_paperSize: '纸张',
  cpd_f_docFonts: '单据字体',
  cpd_f_landAreaUnits: '土地面积单位',
  cpd_f_addressParts: '地址行政区划',
  cpd_f_govPortals: '政府门户',
  cpd_f_immigration: '移民/签证服务',
  cpd_f_bankParsers: '银行对账单解析器',
  cpd_f_statutoryBooks: '法定账簿名称',
  cpd_langs: '界面语言',
  cpd_langs_hint: '取消勾选某种语言,所有语言菜单都不再显示它。按国家/地区包全部勾选时,列表跟随国家/地区。',
  cpd_langs_follow: '跟随国家/地区',
  cpd_langs_custom: '工作区自定',
  cpd_langs_need_one: '至少保留一种语言。',
  cpd_lang_en: '英文',
  cpd_lang_zh: '中文',
  cpd_lang_th: '泰文',
};
export const th: Record<string, string> = {
  cpd_title: 'คุณสมบัติตามประเทศ',
  cpd_hint: 'สิ่งที่ชุดข้อมูลประเทศกำหนดไว้สำหรับเอกสารและงานประจำวัน คุณสมบัติที่ประเทศนั้นไม่มีจะถูกละไว้ และหน้าจอจะใช้ค่าเริ่มต้นกลางแทน',
  cpd_country: 'ประเทศ',
  cpd_country_unset: 'ยังไม่ได้ตั้งค่าประเทศ (ดูหัวข้อภูมิภาคด้านบน) — ทุกคุณสมบัติใช้ค่าเริ่มต้นของระบบ',
  cpd_from_pack: 'ชุดข้อมูลประเทศ',
  cpd_default: 'ค่าเริ่มต้นของระบบ',
  cpd_none: 'ไม่มี',
  cpd_f_paperSize: 'ขนาดกระดาษ',
  cpd_f_docFonts: 'แบบอักษรเอกสาร',
  cpd_f_landAreaUnits: 'หน่วยพื้นที่ที่ดิน',
  cpd_f_addressParts: 'เขตการปกครองในที่อยู่',
  cpd_f_govPortals: 'เว็บไซต์หน่วยงานรัฐ',
  cpd_f_immigration: 'บริการด้านตรวจคนเข้าเมือง',
  cpd_f_bankParsers: 'ตัวอ่านรายการเดินบัญชีธนาคาร',
  cpd_f_statutoryBooks: 'ชื่อบัญชีตามกฎหมาย',
  cpd_langs: 'ภาษาของหน้าจอ',
  cpd_langs_hint: 'ยกเลิกการเลือกภาษาใดเพื่อซ่อนภาษานั้นจากเมนูภาษาทุกแห่ง หากเลือกครบตามที่ประเทศกำหนด รายการจะเป็นไปตามประเทศ',
  cpd_langs_follow: 'ตามประเทศ',
  cpd_langs_custom: 'กำหนดเองสำหรับพื้นที่ทำงาน',
  cpd_langs_need_one: 'ต้องเลือกไว้อย่างน้อยหนึ่งภาษา',
  cpd_lang_en: 'อังกฤษ',
  cpd_lang_zh: 'จีน',
  cpd_lang_th: 'ไทย',
};
